<!-- nav -->
<div class="wrapper">
  <app-drawer>
    <app-top-nav class="top-nav"></app-top-nav>
    <div class="main-layout">
      <aside class="left-nav" [class.shift]="isNavCollapsed"
        [ngStyle]="isNavCollapsed ? { 'box-shadow': '0 0 5px #333' } : {}">

        <app-left-nav></app-left-nav>

        <div class="version">
          <span> {{ version }} </span>
        </div>

      </aside>
      <main class="content-wrapper" [class.shift]="isNavCollapsed">

        <alert [mainScreen]="true"></alert>

        <router-outlet></router-outlet>

      </main>

    </div>
  </app-drawer>
</div>